import axios from 'axios';
const { storage } = require('../../../constants/firebase');
export const getVendorDetails = (uid) => {
  return (dispatch) => {
    dispatch({ type: 'STORE_LOADING' });
    axios
      .get(`/get/vendor/profile/${uid}`)
      .then((data) => {
        dispatch({ type: 'GET_VENDOR_DETAILS', payload: data });
        dispatch({ type: 'STORE_UNLOADING' });
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: 'STORE_UNLOADING' });
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response });
      });
  };
};

export const getVendorOrders = (id) => {
  return (dispatch) => {
    axios
      .get(`/vendor/orders/${id}`)
      .then((data) => {
        dispatch({ type: 'GET_VENDOR_ORDERS', payload: data });
      })
      .catch((error) => {
        console.log(' Vendor Orders not found');
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const getUserOrders = (id) => {
  return (dispatch) => {
    axios
      .get('/user/orders/' + id)
      .then((data) => {
        dispatch({ type: 'GET_USER_ORDERS', payload: data });
      })
      .catch((error) => {
        console.log(' User Orders not found');
        dispatch({ type: 'GET_USER_ORDERS_ERROR', payload: error });
      });
  };
};
export const logoutUser = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('uid');
  localStorage.removeItem('city');
  localStorage.removeItem('userLoginType');
  localStorage.removeItem('cost');
  localStorage.removeItem('promoCost');
  localStorage.removeItem('totalCost');
  localStorage.removeItem('vendorSuperCategoryId');
  dispatch({ type: 'USER_LOGOUT' });
  dispatch({ type: 'CLEAR_CART' });
};

export const singleUpload = (image, callback) => (dispatch) => {
  const uploadTask = storage.ref(`images/${image.name}`).put(image);
  uploadTask.on(
    'state_changed',
    (snapshot) => {
      // const progress = Math.round(
      //   (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      // );
    },
    (error) => {
      console.log(error);
    },
    () => {
      storage
        .ref('images')
        .child(image.name)
        .getDownloadURL()
        .then((url) => {
          callback(url);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  );
};

export const handleUpload = (images, urls, callback) => (dispatch) => {
  // dispatch({type:SET_LOADING})
  images.forEach((image) => {
    const uploadTask = storage.ref(`images/${image.name}`).put(image);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // const progress = Math.round(
        //   (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        // );
      },
      (error) => {
        //dispatch({type:SET_UNLOADING})
        //dispatch({type:SET_ERROR,payload:error})
        console.log(error);
      },
      () => {
        storage
          .ref('images')
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            urls.push(url);
          })
          .then(() => {
            if (urls.length === images.length) {
              //dispatch({type:SET_UNLOADING})
              callback(urls);
            }
          })
          .catch((error) => {
            //dispatch({type:SET_UNLOADING})
            //dispatch({type:SET_ERROR,payload:error})
            console.log(error);
          });
      }
    );
  });
};
